export default __webpack_public_path__ + "static/media/desktop.e1ca4ff9.png";